import { Component, Input, ViewChild, ElementRef, OnDestroy, OnChanges, SimpleChanges, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalConstants } from '../../global-constants';
import { ImagePopupService } from '../../comun/services/image-popup.service';
import { PerfilComponent } from '../perfil.component';
import { ViewportScroller } from '@angular/common';
import { QueryService } from '../../comun/services/query.service';
import { FuncionesService } from '../../comun/services/funciones.service';
// Para cargar el perfil del usuario conectado
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PerfilService } from '../../comun/services/perfil.service';
import { Cuidado } from '../../comun/models/salud-cuidado.model';
import { SaludService } from '../../comun/services/salud.service';
import { forkJoin } from 'rxjs';
import { LoaderService } from '../../comun/services/loader.service';
import { PerfilStatusService } from '../../comun/services/perfil-status.service';
import Swal from 'sweetalert2';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { GeoService } from '../../comun/services/geo.service';
import { finalize, switchMap } from 'rxjs/operators';
import { BreakpointService } from '../../comun/services/breakpoint.service';

@Component({
  selector: 'app-perfil-show',
  templateUrl: './perfil-show.component.html',
  styleUrl: './perfil-show.component.css'
})
export class PerfilShowComponent implements OnChanges {
  @Input() misdatos!: any;
  @Input() perfil!: any;
  busy: number = 0;
  visible: boolean = false;
  private cuidadoSub!: Subscription;
  cuidado: any = {};
  avisos: any[] = [];
  avisoActual = 0;
  avisosCargando = false;
  private avisosSub: Subscription[] = [];

  get avisoVisible(): any | null { return this.avisos[this.avisoActual] || null; }
  get avisoPropio(): boolean { return !!this.perfil?.ID && Number(this.misdatos?.ID) === Number(this.perfil?.ID); }

  moverAviso(paso: number): void {
    if (!this.avisos.length) return;
    this.avisoActual = (this.avisoActual + paso + this.avisos.length) % this.avisos.length;
  }
  seleccionarAviso(indice: number): void { this.avisoActual = indice; }
  getTipoCuidadoVisual(aviso: any): string {
    if (aviso?.tipo !== 'salud') return 'paseo';
    const tipo = String(aviso.tipoCuidado || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (tipo.includes('vacun')) return 'vacuna';
    if (tipo.includes('medic') || tipo.includes('tratamiento')) return 'medicacion';
    if (tipo.includes('revis') || tipo.includes('veter') || tipo.includes('consulta') || tipo.includes('control')) return 'revision';
    if (tipo.includes('higien') || tipo.includes('aseo') || tipo.includes('ban') || tipo.includes('limpieza')) return 'higiene';
    if (tipo.includes('aliment') || tipo.includes('comida') || tipo.includes('dieta')) return 'alimentacion';
    if (tipo.includes('paseo') || tipo.includes('ejercicio') || tipo.includes('actividad')) return 'actividad';
    return 'otro';
  }
  getIconoCuidado(aviso: any): string {
    const iconos: {[tipo: string]: string} = {
      vacuna: 'fa-solid fa-syringe', medicacion: 'fa-solid fa-pills', revision: 'fa-solid fa-stethoscope',
      higiene: 'fa-solid fa-soap', alimentacion: 'fa-solid fa-bowl-food',
      actividad: 'fa-solid fa-person-walking', otro: 'fa-solid fa-heart-pulse', paseo: 'fa-solid fa-person-walking'
    };
    return iconos[this.getTipoCuidadoVisual(aviso)] || iconos['otro'];
  }
  private periodoLabel(c: any): string {
    const labels: {[key: string]: string} = { diaria: 'Diario', semanal: 'Semanal', quincenal: 'Quincenal', mensual: 'Mensual', trimestral: 'Trimestral', semestral: 'Semestral', anual: 'Anual', personalizada: `Cada ${c.mc_intervalo || 1} días` };
    return labels[c.mc_periodicidad] || '';
  }
  private normalizarAvisos(): void {
    this.avisos.sort((a, b) => a.fechaHora.localeCompare(b.fechaHora));
    this.avisoActual = Math.min(this.avisoActual, Math.max(0, this.avisos.length - 1));
  }
  cargarAvisos(): void {
    this.avisosSub.forEach(sub => sub.unsubscribe());
    this.avisosSub = [];
    this.avisos = [];
    this.avisoActual = 0;
    if (!this.avisoPropio) return;
    this.avisosCargando = true;
    const salud = this.query.query('cuidados', 'GET', { limit: 50, intervalo: 3650, realizado: '' }).subscribe({
      next: (r: any) => {
        const cuidados = Array.isArray(r?.registros) ? r.registros : [];
        const hoy = new Date().toLocaleDateString('en-CA');
        this.avisos = [...this.avisos.filter(a => a.tipo !== 'salud'), ...cuidados.filter((c: any) => c.mc_realizado !== 'X').map((c: any) => ({
          id: `salud-${c.mc_id}`, tipo: 'salud', titulo: c.ma_nombre || 'Tu mascota', tipoCuidado: c.va_nombre || 'Cuidado',
          fecha: c.mc_fecha, hora: c.mc_hora || '00:00', fechaHora: `${c.mc_fecha} ${c.mc_hora || '00:00'}`,
          descripcion: c.mc_notas || '', periodicidad: this.periodoLabel(c),
          etiqueta: c.mc_estado === 'hoy' ? 'Hoy toca' : c.mc_estado === 'atrasado' ? 'Pendiente' : 'Próximo cuidado',
          vencido: c.mc_estado === 'atrasado', enlace: this.global.urlServer + 'perfil/' + encodeURIComponent(this.perfil.slug || this.perfil.user_nicename || '') + '/#seccion-salud'
        }))];
        this.normalizarAvisos();
      }, error: () => { this.avisosCargando = false; }
    });
    this.avisosSub.push(salud);
    const paseos = this.query.query('muros', 'AVISOS_PASEOS', {limit: 30}).subscribe({
      next: (r: any) => {
        const registros = Array.isArray(r?.registros) ? r.registros : [];
        this.avisos = [...this.avisos.filter(a => a.tipo !== 'paseo'), ...registros.map((x: any) => ({
          id: `paseo-${x.rs_id}`, tipo: 'paseo', titulo: x.rs_texto_plano || 'Próximo paseo',
          fecha: x.rsp_fecha, hora: x.rsp_hora || '00:00', fechaHora: `${x.rsp_fecha} ${x.rsp_hora || '00:00'}`,
          descripcion: x.rsp_ubicacion ? `Lugar: ${x.rsp_ubicacion}` : '',
          etiqueta: 'Próximo paseo', vencido: false, enlace: this.global.urlServer + 'muros/'
        }))];
        this.normalizarAvisos(); this.avisosCargando = false;
      }, error: () => { this.avisosCargando = false; }
    });
    this.avisosSub.push(paseos);
  }

  global: any = GlobalConstants;
  selectedFiles: any = { imagenes: [], previewUrl: [] };
  editando: boolean = false;
  @ViewChild('fileInputPrincipal') fileInputPrincipal!: ElementRef<HTMLInputElement>;
  previewUrl: string | ArrayBuffer | null = null;  

  // Guarda el nombre del campo que se está editando (ej: 'first_name', 'bio')
  campoEditando: keyof any | null = null; 
  // Copia temporal para el valor que se está modificando
  valorTemporal: string = '';

  inputBuscador = new FormControl('');
  sugerencias$: Observable<any[]> = of([]);
  mostrarDesplegable = false;
  getgeo: boolean = false;
  // para saber en que d- de bootstrap se está aplicando ('xs', 'sm', 'md', 'lg', 'xl' o 'xxl')
  bp = inject(BreakpointService);

  constructor(public app: PerfilComponent,
              private http: HttpClient,
              public imagepopup: ImagePopupService,
              private scroller: ViewportScroller,
              private query: QueryService,
              public funciones: FuncionesService,
              private perfilService: PerfilService,
              private saludService: SaludService,
              private loader: LoaderService,
              public geoService: GeoService,
              private statusService: PerfilStatusService
              ) { }

  ngOnInit() {
    if (this.perfil.user_new)
      this.editando = true;

    this.sugerencias$ = this.inputBuscador.valueChanges.pipe(
      debounceTime(400),        // Espera 400ms después de que el usuario deja de escribir
      distinctUntilChanged(),   // Evita buscar si el texto es idéntico al anterior
      switchMap(texto => {
        if (texto && texto.length > 3) { // Busca solo si hay más de 3 caracteres
          this.mostrarDesplegable = true;
          return this.app.geoService.buscarDireccion(texto).pipe(
            catchError(() => {
              this.mostrarDesplegable = false;
              return of([]); // Si hay error en la API, devuelve array vacío para no romper el flujo
            })
          );
        } else {
          this.mostrarDesplegable = false;
          return of([]);
        }
      })
    );
  }    

  seleccionarDireccion(direccion: any) {
    // Al hacer click, rellenamos el input con el nombre completo
    this.inputBuscador.setValue(direccion.display_name, { emitEvent: false });
    this.mostrarDesplegable = false;

    // Aquí ya tienes las coordenadas exactas de lo que eligió el usuario:
    //console.log('Dirección seleccionada:', direccion);
    //console.log('Latitud:', direccion.lat, 'Longitud:', direccion.lon);
    
    this.perfil.geolatitud = direccion.lat;
    this.perfil.geolongitud = direccion.lon;

    this.perfil.provincia = direccion.province;
    this.perfil.ciudad = direccion.city;
    this.perfil.estado = direccion.state;
    this.perfil.pais = direccion.country;
    this.perfil.cdpostal = direccion.postcode;
    this.perfil.barrio = direccion.suburb;
    /*this.query.query('misdatos', 'SAVE', this.misdatos).subscribe((resultado:any) => {
      this.misdatos.editando = false;
      this.getPerfil();
    });*/

    this.perfil.direccionfisica = direccion.display_name;
  }

  ngAfterViewInit() {
    this.imagepopup.init();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['misdatos'] || changes['perfil']) && this.misdatos?.ID) {
      this.getcuidado();
      if (this.perfil?.ID) this.cargarAvisos();
    }
  }

  ngOnDestroy(): void {
    this.cuidadoSub?.unsubscribe();
    this.avisosSub.forEach(sub => sub.unsubscribe());
  }

  opcionesPerfil() {
    window.location.href = GlobalConstants.urlServer + 'opciones';
  }

  editarPerfil() {
    if (this.editando)
      this.guardarPerfil();
    this.editando = !this.editando;
  }

  cancelarPerfil() {
    this.getPerfil();
    this.editando = !this.editando;
  }

  getcuidado() {
    // 1. Escuchamos el observable
    this.cuidadoSub?.unsubscribe();
    this.cuidadoSub = this.saludService.cuidado$
      .pipe(
        // 2. FILTRO: Si es null, no pasa. Solo continúa si tiene datos reales.
        filter((cuidado): cuidado is Cuidado => cuidado !== null)
      )
      .subscribe((cuidado: Cuidado) => {
        // Ya tenemos datos
        this.cuidado = cuidado;
        if (this.avisoPropio) this.cargarAvisos();
      });
    /*if (this.misdatos.ID != this.perfil.ID) return;

    this.query.query('cuidados', 'GET', { limit: 1, intervalo: 0, realizado: '' }).subscribe((resultado:any) => {
      this.cuidado = resultado.registros[0] || {};
    });*/
  }

  // Activa la edición del campo seleccionado
  activarEdicion(campo: keyof any) {
    this.campoEditando = campo;
    this.valorTemporal = this.perfil[campo];
  }  

  // Guarda los cambios del campo activo
  /*guardarCambios() {
    if (!this.campoEditando) return;
    console.log('Guardando perfil con datos:', this.perfil);

    const campoActual = this.campoEditando;
    const nuevoValor = this.valorTemporal.trim();

    // Si el valor no cambió, cerramos el modo edición sin hacer nada
    if (nuevoValor === this.perfil[campoActual]) {
      this.campoEditando = null;
      return;
    }

    // Actualizamos el modelo local
    this.perfil[campoActual] = nuevoValor;
    this.campoEditando = null;

    // Enviamos al backend el campo actualizado y su nuevo valor
    this.guardarPerfil();
  }*/

  guardarPerfil(refresh: boolean = false) {
    this.loader.show();
    this.query.query('misdatos', 'SAVE', this.perfil).subscribe((resultado:any) => {
      localStorage.setItem('validaPerfil', 'X');
      const llamadas: any[] = [];
      if (this.perfil.data != null && this.perfil.data != '') {
        const formData = new FormData();
        formData.append('data', this.perfil.data);
        formData.append('principal', 'X');
        formData.append('tipo', 'PE');
        formData.append('tipo_id', '0');
        const token = localStorage.getItem('token');
        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        llamadas.push(this.http.post(GlobalConstants.urlServer + 'backend/api/upload.php', formData, { headers }));
      }      
      if (this.selectedFiles.imagenes.length > 0) {
        for (const imagen of this.selectedFiles.imagenes) {
          const formData = new FormData();
          formData.append('data', imagen);
          // Si es la primera es la foto principal
          if (this.selectedFiles.imagenes.length == 1)
            formData.append('principal', 'X');
          else
            formData.append('principal', '');
          formData.append('tipo', 'PE');
          formData.append('tipo_id', '0');
          const token = localStorage.getItem('token');
          const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
          llamadas.push(this.http.post(GlobalConstants.urlServer + 'backend/api/upload.php', formData, { headers }));
        }
      }
      if (this.perfil.foto.borrada) {
        llamadas.push(this.query.query('misdatos', 'DELETE_FOTO', { ft_id: this.perfil.foto.foto_principal_id }));
      }
      if (llamadas.length == 0) {
        if (refresh) {
          window.location.reload();
        } else {
          this.getPerfil();
          this.app.editandoperfil = false;
          this.statusService.notificarCambioLocal();
          this.funciones.scrollToTop();
          this.loader.hide();
        }
      }
      // Convertir array → objeto para evitar deprecación
      const llamadasObj = llamadas.reduce((acc, obs, i) => {
        acc[i] = obs;
        return acc;
      }, {} as { [key: string]: any });

      forkJoin(llamadasObj).subscribe(resultados => {    
        if (refresh) {
          window.location.reload();
        } else {
          this.getPerfil();
          this.app.editandoperfil = false;
          this.statusService.notificarCambioLocal();
          this.funciones.scrollToTop();
          this.loader.hide();
        }
      });
    });
  }

  getPerfil() {
    this.query.query('misdatos', 'GET', { ID: this.perfil.ID }).subscribe((resultado:any) => {
      this.misdatos.user_new = false;
      // No perder la foto actual si la API devuelve el perfil sin datos de imagen.
      // Cuando el backend sí devuelve la nueva foto, prevalece sobre la anterior.
      const fotoAnterior = this.perfil?.foto;
      if (resultado && typeof resultado === 'object') {
        const fotoNueva = resultado.foto;
        const fotoValida = fotoNueva && (
          fotoNueva.foto_principal_thumb || fotoNueva.foto_principal_grande
        );
        if (!fotoValida && fotoAnterior && !fotoAnterior.borrada) {
          resultado.foto = fotoAnterior;
        }
      }
      this.perfil = resultado;
      this.perfilService.setPerfil(this.perfil);
      // Publicar EXACTAMENTE el mismo perfil que se muestra, incluida su foto.
      // No realizar otra consulta GET sin ID que pueda reemplazarla parcialmente.
      if (Number(this.perfil?.ID) === Number(this.misdatos?.ID)) {
        this.app.publicarMisDatosPerfil(this.perfil);
      }
    });
  }

  onClickImagenPrincipal() {
    // Simula el click en el input file
    this.fileInputPrincipal.nativeElement.click();
  }

  onFileSelectedPrincipal(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {

      // PREVIEW LOCAL
      const file = input.files[0];

      // Guardar la imagen original sin recortar
      const readerOriginal = new FileReader();
      readerOriginal.onload = () => {
        this.perfil.data = readerOriginal.result; // imagen original
        //this.guardarPerfil();
      };
      readerOriginal.readAsDataURL(file);

      this.funciones.recortarImagenCuadrada(file, 500)
        .then((dataUrl) => {
          this.previewUrl = dataUrl;   // preview           
          // La imagen ya cambió, se recortó y está lista para guardarse
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }

  calcularEdad() {
    this.perfil.edad = this.funciones.calcularEdad(this.perfil.fecha_nac);
  }

  borrarFoto() {
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres borrar tu foto de perfil?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        /*cancelButton: 'custom-swal-cancel'*/
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.perfil.foto.borrada = true;
        this.perfil.foto.foto_principal_thumb = GlobalConstants.urlServer + 'img/default-user.png';
        this.perfil.foto.foto_principal_grande = GlobalConstants.urlServer + 'img/default-user.png';
        this.previewUrl = null;
      } else {
      }
    });
  }

  async permisoGeolocalizacion(check: boolean = true) {
    const valorAnterior = this.inputBuscador.value;

    this.inputBuscador.disable();
    this.inputBuscador.setValue('Localizando...');

    const checkGeo = this.checkLocalPermisoUbicacion();
    if (checkGeo == 'si' || checkGeo == null || check == false) {
      const permiso = await this.geoService.checkPermission();

      // Si el usuario a permitido
      if (permiso === 'granted') {
        this.obtenerUbicacionExacta();
      // Permiso denegado pregunta si quiere reintentar
      } else if (permiso === 'denied') {
        this.preguntaReintentarUbicacion();
      // No lo ha permitido o espera la pregunta
      } else {
        this.obtenerUbicacionAproximada();
        this.preguntaUsarUbicacion();
      }
    } else {
      this.obtenerUbicacionAproximada();
    }
  }

obtenerUbicacionExacta() {
    this.getgeo = true;
    const direccionAnterior = this.perfil.direccionfisica;
    this.perfil.direccionfisica = 'Localizando...';
    this.inputBuscador.disable();

    this.geoService.getExactPosition().pipe(
      switchMap(position => {
        this.perfil.geolatitud = position.coords.latitude;
        this.perfil.geolongitud = position.coords.longitude;

        return this.geoService.getGeo(
          this.perfil.geolatitud,
          this.perfil.geolongitud
        );
      }),
      finalize(() => {
        this.getgeo = false;
        this.inputBuscador.enable();
      })
    )
    .subscribe({
      next: datos => {
        this.perfil.ciudad = datos.city;
        this.perfil.estado = datos.state;
        this.perfil.pais = datos.country;
        this.perfil.cdpostal = datos.postcode;
        this.perfil.barrio = datos.barrio;
        this.perfil.direccionfisica = datos.display_name;        
        this.setLocalPermisoUbicacion(true);
      },
      error: err => {
        this.perfil.direccionfisica = direccionAnterior;
        this.perfil.ciudad = 'Ubicación no disponible';        
      }
    });
  }
  
  obtenerUbicacionAproximada() {
    // Primero usamos IP (sin popup)
    this.geoService.getApproximatePosition().subscribe(datos => {
      this.perfil.ciudad = datos.city;
      this.perfil.estado = datos.region;
      this.perfil.pais = datos.country;
      this.perfil.cdpostal = datos.postcode;
      this.perfil.barrio = '';
    });
  }
  
  preguntaUsarUbicacion() {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Sí, permitir',
      cancelButtonText: 'No, gracias',
      timer: 0, // No se cierra automáticamente
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      },
      customClass: {
        popup: '',
        confirmButton: 'btn btn-sm btn-success me-2',
        cancelButton: 'btn btn-sm btn-danger'
      },
      buttonsStyling: false
    });

    Toast.fire({
      icon: 'question',
      title: '¿Nos dejas usar tu ubicación?',
      text: 'Para ofrecerte una mejor experiencia y mostrarte perfiles cerca de tu zona, necesitamos acceder a tu ubicación exacta. Esto nos permitirá sugerirte personas y servicios más relevantes y cercanos. ¿Deseas permitir que usemos tu ubicación?'
    }).then((result) => {
      if (result.isConfirmed) {
        this.obtenerUbicacionExacta();
      } else if (result.isDismissed) {
        this.setLocalPermisoUbicacion(false);
      }
    });
  }

  preguntaReintentarUbicacion() {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Reintentar',
      cancelButtonText: 'No, gracias',
      timer: 0, // No se cierra automáticamente
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      },
      customClass: {
        popup: '',       // Sombra para destacar
        confirmButton: 'btn btn-sm btn-success me-2',
        cancelButton: 'btn btn-sm btn-danger'
      },
      buttonsStyling: false
    });

    Toast.fire({
      icon: 'question',
      title: '¿Nos dejas usar tu ubicación?',
      text: 'Tienes bloqueada la ubicación. Para activarla haz clic en el candado de la barra de direcciones, permisos, cambia Ubicación a "Permitir" y finalmente haz clic en el botón "Reintentar"'
    }).then((result) => {
      if (result.isConfirmed) {
        this.permisoGeolocalizacion();
      } else if (result.isDismissed) {
        this.setLocalPermisoUbicacion(false);
      }
    });
  }

  setLocalPermisoUbicacion(allow: boolean) {
    localStorage.setItem('permisoUbicacion' + this.perfil.ID, allow ? 'si' : 'no');    
  }
  checkLocalPermisoUbicacion(): string | null {
    return localStorage.getItem('permisoUbicacion' + this.perfil.ID); // 'si', 'no' o null si no existe
  }  
 
}
